import st_taro from './st_taro'

export default st_taro